


import { HiHome, HiUsers } from "react-icons/hi";
import { FaFlag, FaReceipt, FaUserTie, FaUser, FaLock } from "react-icons/fa";
import { Sidebar } from "flowbite-react";
import { FaShop } from "react-icons/fa6";
import { FaClipboardList } from "react-icons/fa";
import { RiCalendarScheduleFill } from "react-icons/ri";
import { PiHandWithdrawFill, PiTruckTrailerFill } from "react-icons/pi";
import { MdAttachMoney, MdInventory, MdSettings } from "react-icons/md";
import { useAppSelector } from "../../Reducers/store";
import { useNavigate } from "react-router-dom";

interface SideNavProps {
  isDriver?: boolean;
}


export default function SideNav({ isDriver }: SideNavProps) {
  const { userModel } = useAppSelector((state) => state.user);
  const navigate = useNavigate();

  // Handler for logout
  const handleLogout = () => {
    localStorage.removeItem("FuelProToken");
    navigate("/login");
  };

  // Define minimal/filtered nav for drivers
  const driverNav = [
    { href: "/", icon: HiHome, label: "Schedule" },
    { href: "/delivery/list", icon: FaReceipt, label: "Deliveries" },
    { href: "/orders", icon: FaClipboardList, label: "Orders" },
    { href: "/assets", icon: PiTruckTrailerFill, label: "Assets" },
    { href: "/inspections", icon: FaFlag, label: "Inspections" },
    userModel && { href: `/user/${userModel.id}`, icon: FaUser, label: "Profile" },
    { isLogout: true, icon: FaLock, label: "Logout" },
  ].filter(Boolean);

  const fullNav = [
    { href: "/", icon: HiHome, label: "Schedule" },
    { href: "/inventory/prices", icon: MdAttachMoney, label: "Daily Prices" },
    { href: "/clients", icon: FaUserTie, label: "Clients" },
    { href: "/jobs", icon: RiCalendarScheduleFill, label: "Jobs" },
    { href: "/delivery/list", icon: FaReceipt, label: "Deliveries" },
    { href: "/inventory/list", icon: MdInventory, label: "Inventory" },
    { href: "/orders", icon: FaClipboardList, label: "Orders" },
    { href: "/vendors", icon: FaShop, label: "Vendors" },
    { href: "/assets", icon: PiTruckTrailerFill, label: "Assets" },
    { href: "/inspections", icon: FaFlag, label: "Inspections" },
    { href: "/reimbursements", icon: PiHandWithdrawFill, label: "Reimbursements" },
    { href: "/users", icon: HiUsers, label: "Users" },
    { href: "/admin", icon: MdSettings, label: "Admin" },
    { isLogout: true, icon: FaLock, label: "Logout" },
  ];

  const navItems = isDriver ? driverNav : fullNav;

  return (
    <div className="sticky bg-slate-100 h-full hidden lg:block">
      <Sidebar className="bg-slate-100 w-[60px] lg:w-[256px] transition-width transition-slowest">
        <Sidebar.Items>
          <Sidebar.ItemGroup>
            {navItems.map((item) => {
              if ((item as any).isLogout) {
                return (
                  <div className="flex content-center" key={"logout"}>
                    <Sidebar.Item icon={item.icon} onClick={handleLogout} className="cursor-pointer">
                      <div className="hidden lg:block">{item.label}</div>
                    </Sidebar.Item>
                  </div>
                );
              }
              return (
                <div className="flex content-center" key={item.href}>
                  <Sidebar.Item href={item.href} icon={item.icon}>
                    <div className="hidden lg:block">{item.label}</div>
                  </Sidebar.Item>
                </div>
              );
            })}
          </Sidebar.ItemGroup>
        </Sidebar.Items>
      </Sidebar>
    </div>
  );
}
